export const isPrerenderIoBot = (): boolean =>
  typeof navigator !== 'undefined' &&
  (navigator.userAgent.includes('Prerender') || navigator.userAgent.includes('prerender'));
